import assign from 'lodash.assign';
export class TenderingCriterionPropertyGroup {
    constructor(init) {
        assign(this, init);
    }
    _cardinality;
    _maxOccurrence;
    id;
    description;
    propertyGroupTypeCode;
    fulfilmentIndicatorTypeCode;
    tenderingCriterionProperties;
    subsidiaryTenderingCriterionPropertyGroups;
}
